import { apolloClient } from "@td/ui";
import PRACTICE_TEAMS_QUERY from "../queries/practice-teams.graphql";

const responseSelector = ({ data: { practiceTeamSearch: { edges }}}) => edges.map(({ node: { id, name, states }}) => ({
  value: id,
  label: name,
  states: states,
}));

const loadPracticeTeams = async (params) => {
  const data = await apolloClient.query({
    query: PRACTICE_TEAMS_QUERY,
    variables: {
      params,
    },
    fetchPolicy: "network-only",
  });

  return responseSelector(data);
};

export default loadPracticeTeams;
